import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

import { EmailReminderFieldsFragment } from '../common';

export type EmailReminder = {
  id: number;
  message: string;
  subject: string;
  datetime: string;
  notifyStatus: number;
  selectedGuestStatuses: number[];
  schedule: {
    quantity: number;
    unit: string;
    beforeEventBegins: boolean;
  };
};

type UpsertEmailReminderResult = {
  ok: boolean;
  emailReminder: EmailReminder;
};

/**
 * Upsert can have id optional.
 */
export interface UpsertEmailReminderInput extends Pick<EmailReminder, 'message' | 'subject'> {
  id?: number;
  eventId: number;
  datetime?: string;
  schedule?: {
    quantity?: number;
    unit?: string;
    beforeEventBegins?: boolean;
  };
  selectedGuestStatuses?: string[];
}

const UpsertEmailReminderMutation = gql`
  mutation UpsertEventEmailReminder($input: EmailReminderInput!) {
    upsertEventEmailReminder(input: $input) {
      ok
      emailReminder {
        ...EmailReminderFieldsFragment
      }
    }
  }
  ${EmailReminderFieldsFragment}
`;

export interface DeleteEmailReminderInput {
  id: number;
  eventId: number;
}

type DeleteEmailReminderResult = {
  ok: boolean;
};

const DeleteEmailReminderMutation = gql`
  mutation DeleteEventEmailReminder($input: DeleteEventReminderInput!) {
    deleteEventEmailReminder(input: $input) {
      ok
    }
  }
`;

export const emailRemindersApi = {
  upsert: ({ input }: { input: UpsertEmailReminderInput }): Promise<UpsertEmailReminderResult> => {
    return gqlClient
      .request<{ upsertEventEmailReminder: UpsertEmailReminderResult }>(
        UpsertEmailReminderMutation,
        {
          input
        }
      )
      .then((res) => res.upsertEventEmailReminder);
  },
  delete: ({ input }: { input: DeleteEmailReminderInput }): Promise<DeleteEmailReminderResult> => {
    return gqlClient
      .request<{ deleteEventEmailReminder: DeleteEmailReminderResult }>(
        DeleteEmailReminderMutation,
        { input }
      )
      .then((res) => res.deleteEventEmailReminder);
  }
};
